import { EcoSpecSelectorItemType } from 'eco-design/sections/eco-spec-selector/type';
import { formatSpecImg } from './formatSpecImg';

const _getSpecValue = (product: any, group: any, param: any) => {
    const ownSpec = product && product.skuList && product.skuList?.length && product?.skuList[0]?.ownSpec;
    const ownSpecObj = JSON.parse(typeof ownSpec === 'string' ? ownSpec : JSON.stringify(ownSpec) || '{}');
    const ownSpecGroup = ownSpecObj[group?.specGroupId];
    const ownSpecGroupObj = JSON.parse(typeof ownSpecGroup === 'string' ? ownSpecGroup : JSON.stringify(ownSpecGroup) || '{}');
    let specV = ownSpecGroupObj[param?.specParamId];
    if (param?.fieldType === 'boolean') {
        const v = !specV ? '-' : ['false'].includes(specV) ? '-' : '✓';
        return v;
    }
    if (!Number.isNaN(Number(specV))) {
        specV = specV + (param?.unit || '');
    }
    return String(specV).endsWith(' [* *]') ? String(specV).split(' [* *]')[0] : specV || '-';
};

export function formatSpecs(data: any[]) {
    if (!Array.isArray(data) || data?.length <= 0) return;
    const arr = [] as EcoSpecSelectorItemType[];
    data?.map((item: any) => {
        const temp = {} as EcoSpecSelectorItemType;
        temp.img = formatSpecImg(item?.productDetail);
        temp.paramGroups = [];
        if (Array.isArray(item?.productCatagory) && item?.productCatagory[0]) {
            item?.productCatagory[0]?.specGroupList?.map((specGroup: any) => {
                const temp2: any = {};
                temp2.title = specGroup?.name;
                temp2.params = [];
                specGroup?.specParamList?.map((specParam: any) => {
                    const specValue = _getSpecValue(item?.productDetail, specGroup, specParam);
                    if (specValue !== '-') {
                        temp2.params.push({
                            title: specParam.name,
                            desc: specValue,
                        });
                    }
                });
                if (temp2.params?.length > 0) {
                    temp.paramGroups?.push(temp2);
                }
            });
            arr.push(temp);
        }
    });
    return arr;
}
